import {
  GET_FINANCE_LOAN_DETAILS_FAILURE,
  GET_FINANCE_LOAN_DETAILS_LOADING,
  GET_FINANCE_LOAN_DETAILS_SUCCESS,
} from "../../actions/types";

const INITIAL_STATE = {
  loan: {
    get: {
      loading: false,
      reset: false,
      success: {
        ok: false,
        data: null,
      },
      failure: {
        error: false,
        message: "",
      },
    },
  },
};

const getFinanceLoanReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_FINANCE_LOAN_DETAILS_LOADING:
      return {
        ...state,
        loan: {
          ...state.loan,
          get: {
            ...state.loan.get,
            loading: true,
            reset: false,
            success: {
              ...state.loan.get.success,
              ok: false,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case GET_FINANCE_LOAN_DETAILS_SUCCESS:
      return {
        ...state,
        loan: {
          ...state.loan,
          get: {
            ...state.loan.get,
            loading: false,
            reset: false,
            success: {
              ...state.loan.get.success,
              ok: true,
              data: action.payload,
            },
            failure: {
              error: false,
              message: "",
            },
          },
        },
      };
    case GET_FINANCE_LOAN_DETAILS_FAILURE:
      return {
        ...state,
        loan: {
          ...state.loan,
          get: {
            ...state.loan.get,
            loading: false,
            reset: false,
            success: {
              ...state.loan.get.success,
              ok: false,
              data: null,
            },
            failure: {
              error: true,
              message: action.payload.message,
            },
          },
        },
      };
    default:
      return INITIAL_STATE;
  }
};

export default getFinanceLoanReducer;
